
const model = {
  id: 0,
  emailAddress: '',
  fullName: '',
  isSuperAdmin: false,
  isCseitTrained: true,
  active: true,
  isRemoved: false,
  password: '',
  acceptedTosAt: 0,
  acceptedEUA: 0,
  primaryOrganization: {}
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/user.js